import { IRequest } from '@r1-frontend/shared/types/IRequest';

interface IQrLinkRequestProps {
    providerId: number,
    userAgreement: string,
    paySum: number,
}

const AMOUNT_IN_KOPECKS = 100;

/*
* Получение qr-кода
* https://master.api-pay.sandbox.d2c.r-one.io/docs/v2#/VTB%20%D0%B1%D1%8B%D1%81%D1%82%D1%80%D1%8B%D0%B5%20%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B8/aa52a109f8d5e9b593ca97af7d58ea39
*/

export const getQrLink = ({ providerId, userAgreement, paySum }: IQrLinkRequestProps): IRequest =>{
    const postParams = {
        agreement_number: userAgreement,
        pay_amount: paySum * AMOUNT_IN_KOPECKS,
    };

    return {
        uri: '/vtb-pay/create-and-get-qr-code',
        method: 'POST',
        queryParams: {
            providerId,
        },
        withProvider: true,
        body: JSON.stringify(postParams),
    };
};

